import { BaseFetch } from "../main-model"
export default class StrategicModel extends BaseFetch {
    getStrategicBy = (data) =>
    this.authFetch({
      url: "strategic/getStrategicBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getStrategicById = (data) =>
    this.authFetch({
      url: "strategic/getStrategicById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateStrategicById = (data) =>
    this.authFetch({
      url: "strategic/updateStrategicById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertStrategic = (data) =>
    this.authFetch({
      url: "strategic/insertStrategic",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteStrategicById = (data) =>
    this.authFetch({
      url: "strategic/deleteStrategicById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
